export default function AzureAd({
  className
}: {
  size?: number
  className?: string
}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
    >
      <g clipPath="url(#clip0_627_975)">
        <g clipPath="url(#clip1_627_975)">
          <path
            fill="#C3CED9"
            d="M5.37955 14.4729C5.72444 14.6881 6.29777 14.9272 6.90399 14.9272C7.45599 14.9272 7.96888 14.7672 8.39377 14.4943C8.39377 14.4943 8.39466 14.4943 8.39555 14.4934L9.99999 13.4907V17.1112C9.74577 17.1112 9.48977 17.0418 9.26755 16.9032L5.37955 14.4729Z"
          ></path>
          <path
            fill="white"
            d="M8.98044 3.33958L2.31377 10.8596C1.79911 11.4409 1.93333 12.3191 2.60089 12.736C2.60089 12.736 5.06844 14.2782 5.37955 14.4729C5.72444 14.688 6.29777 14.9271 6.904 14.9271C7.456 14.9271 7.96889 14.7671 8.39377 14.4942C8.39377 14.4942 8.39466 14.4942 8.39555 14.4934L10 13.4907L6.12089 11.0658L10.0009 6.68892V2.88892C9.624 2.88892 9.24711 3.03914 8.98044 3.33958Z"
          ></path>
          <path
            fill="#C3CED9"
            d="M17.3991 12.736C18.0667 12.3191 18.2009 11.4408 17.6862 10.8595L13.312 5.92529C12.9591 5.76085 12.5636 5.66663 12.1449 5.66663C11.3227 5.66663 10.5876 6.02129 10.0987 6.57863L10.0018 6.68796L13.8809 11.0648L10.0009 13.4897V17.1102C10.256 17.1102 10.5102 17.0408 10.7324 16.9022L17.3991 12.7351V12.736Z"
          ></path>
          <path
            fill="white"
            d="M10.0009 2.88892V6.68892L10.0978 6.57958C10.5867 6.02225 11.3218 5.66758 12.144 5.66758C12.5636 5.66758 12.9582 5.76269 13.3111 5.92625L11.0187 3.34047C10.7529 3.04003 10.376 2.8898 10 2.8898L10.0009 2.88892Z"
          ></path>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_627_975">
          <rect fill="white" height="20" width="20"></rect>
        </clipPath>
        <clipPath id="clip1_627_975">
          <rect
            transform="translate(2 2)"
            fill="white"
            height="16"
            width="16"
          ></rect>
        </clipPath>
      </defs>
    </svg>
  )
}
